<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="el-main-content">
        <div
            class="el-grid-card"
            style="width: 100%; padding: 10px; background-color: #323b49"
        >
            <div class="el-grid-card__header" style="color: white; padding: 0">
                {{ $t('form.label.manageUsers') }}
            </div>
        </div>

        <div
            class="el-grid-card"
            style="
                width: 100%;
                padding: 10px 10px 30px 10px;
                background-color: #323b49;
            "
        >
            <el-row>
                <v-btn
                    @click.stop="openAddUsersView"
                    dark
                    class="container-btn-toggle"
                    color="primary"
                    style="border-radius: 0px !important"
                    >{{ $t('form.label.addUsers') }}
                </v-btn>
            </el-row>
            <el-row>
                <h4 style="color: #fff; margin-top: 10px">
                    {{ $t('navigation.users') }}
                </h4>
            </el-row>
            <el-row>
                <el-table
                    :data="usersInGroup"
                    size="mini"
                    highlight-current-row
                    :empty-text="$t('message.warning.nodataSelectContainer')"
                    class="w-full mb-6"
                    style="width: 100%; margin-top: 10px"
                    v-loading="loading"
                    border
                >
                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'FirstName')"
                        prop="FirstName"
                        :label="$t('form.label.firstName')"
                    ></el-table-column>

                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'LastName')"
                        prop="LastName"
                        :label="$t('form.label.lastName')"
                    ></el-table-column>

                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'UserName')"
                        prop="UserName"
                        :label="$t('form.label.email')"
                    ></el-table-column>

                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'Company')"
                        prop="Company"
                        :label="$t('form.label.company')"
                    ></el-table-column>

                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'Phone')"
                        prop="Phone"
                        :label="$t('form.label.phone')"
                    ></el-table-column>
                    <el-table-column
                        :label="$t('table.column.operations')"
                        width="100"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <div class="btn-action-wrapper">
                                <a href="#" class="btn-action" title="Delete">
                                    <v-btn
                                        flat
                                        icon
                                        color="red darken-3"
                                        :disabled="isDeleteInProgress"
                                        @click.prevent="deleteUser(row)"
                                    >
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </div>

        <div>
            <el-dialog
                :visible.sync="showAddUsersView"
                width="50%"
                :modalAppendToBody="false"
            >
                <span slot="title">
                    <div class="flex justify-between">
                        <span>{{ $t('form.label.addUsers') }}</span>
                    </div>
                </span>
                <el-row>
                    <el-table
                        :data="usersFullListLocal"
                        size="mini"
                        highlight-current-row
                        :empty-text="
                            $t('message.warning.nodataSelectContainer')
                        "
                        class="w-full mb-6"
                        style="width: 100%"
                        v-loading="loading"
                        border
                    >
                        <el-table-column width="100" :resizable="false">
                            <template slot-scope="{ row }">
                                <div class="btn-action-wrapper">
                                    <el-checkbox
                                        @change="addUser(row)"
                                    ></el-checkbox>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            sortable
                            :sort-method="(a, b) => sortBy(a, b, 'FirstName')"
                            prop="FirstName"
                            :label="$t('form.label.firstName')"
                        ></el-table-column>

                        <el-table-column
                            sortable
                            :sort-method="(a, b) => sortBy(a, b, 'LastName')"
                            prop="LastName"
                            :label="$t('form.label.lastName')"
                        ></el-table-column>

                        <el-table-column
                            sortable
                            :sort-method="(a, b) => sortBy(a, b, 'UserName')"
                            prop="UserName"
                            :label="$t('form.label.email')"
                        ></el-table-column>

                        <el-table-column
                            sortable
                            :sort-method="(a, b) => sortBy(a, b, 'Company')"
                            prop="Company"
                            :label="$t('form.label.company')"
                        ></el-table-column>
                    </el-table>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <v-btn
                            style="float: right; z-index: 999; margin-top: 25px"
                            round
                            color="primary"
                            dark
                            @click.stop="addUsers()"
                        >
                            {{ $t('modal.button.done') }}
                        </v-btn>
                    </el-col>
                </el-row>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import InteractWithSort from '../../mixins/interact-with-sort'

Vue.prototype._ = _

export default {
    name: 'users-manage',
    props: {
        usersOriginalFullList: Array,
    },
    data() {
        return {
            usersInGroup: [],
            showAddUsersView: false,
            loading: false,
            selectedGroup: {},
            usersToAdd: [],
            usersFullListLocal: [],
            isDeleteInProgress: false,
            isEditMode: false,
        }
    },
    created() {
        this.usersInGroup = []
        this.usersToAdd = []
        this.usersFullListLocal = _.cloneDeep(this.usersOriginalFullList)
        Events.$on('group-editing', async (data) => {
            this.isEditMode = true
            this.selectedGroup = data
            this.usersInGroup = data.Users
            this.usersFullListLocal = _.cloneDeep(this.usersOriginalFullList)
            this.usersInGroup.forEach((user) => {
                _.remove(
                    this.usersFullListLocal,
                    (o) => o.UserID === user.UserID
                )
            })
        })
    },
    updated() {},
    mounted() {},
    mixins: [InteractWithSort],
    components: {},
    watch: {},
    computed: {
        ...mapGetters(['selectedContainer']),
    },
    methods: {
        addUser(user) {
            const existingUser = _.filter(this.usersInGroup, {
                UserID: user.UserID,
            })
            if (existingUser && existingUser.length > 0) {
                try {
                    this.$alert(
                        this.$i18n.i18next.t(
                            'message.warning.userAlreadyAdded'
                        ),
                        {
                            confirmButtonText: 'OK',
                        }
                    )
                    return false
                } catch (e) {
                    return false
                }
                return
            } else {
                this.usersToAdd.push({
                    UserID: user.UserID,
                    FirstName: user.FirstName,
                    LastName: user.LastName,
                    UserName: user.UserName,
                    RelatedActorID: user.RelatedActorID,
                    Company: user.Company,
                    Phone: user.Phone,
                    Culture: user.Culture,
                    Permissions: null,
                })
            }
        },
        // notifyFinalUserListForTheGroup() {
        //     const userIdList = this.usersInGroup.map((user) => user.UserID)
        //     Events.$emit('user-manage', userIdList)
        // },
        openAddUsersView() {
            this.showAddUsersView = true
            this.usersToAdd = []
            const temp = _.cloneDeep(this.usersFullListLocal)
            this.usersFullListLocal = []
            this.$nextTick(() => {
                this.usersFullListLocal = temp
                // this.$forceUpdate()
            })
        },
        async addUsers() {
            try {
                if (this.usersToAdd && this.usersToAdd.length > 0) {
                    await this.$confirm(
                        this.$i18n.i18next.t(
                            'message.warning.usersAddConfirm',
                            {
                                section: 'notification',
                            }
                        ),
                        'Warning',
                        {
                            confirmButtonText: this.$i18n.i18next.t(
                                'button.text.confirm'
                            ),
                            cancelButtonText: this.$i18n.i18next.t(
                                'button.text.cancel'
                            ),
                            type: 'warning',
                        }
                    )
                    this.showAddUsersView = false
                    let requestObj = {
                        Users: _.map(this.usersToAdd, 'UserID'),
                    }
                    this.usersInGroup.push(...this.usersToAdd)
                    this.usersToAdd.forEach((user) => {
                        _.remove(
                            this.usersFullListLocal,
                            (o) => o.UserID === user.UserID
                        )
                    })
                    if (this.isEditMode) {
                        await this.$http.post(
                            `/UserGroup/${this.selectedGroup.UserGroupID}/AddUsers`,
                            requestObj
                        )
                    } else {
                        Events.$emit(
                            'user-manage',
                            _.map(this.usersInGroup, 'UserID')
                        )
                    }
                    this.updateUserListInParentView()
                } else {
                    this.showAddUsersView = false
                    return false
                }
            } catch (e) {
                return false
            }
        },
        async deleteUser(user) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: this.$i18n.i18next.t('text.user'),
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )
                this.isDeleteInProgress = true
                _.remove(this.usersInGroup, (existingUser) => {
                    return existingUser.UserID === user.UserID
                })
                this.usersFullListLocal.push(user)
                if (this.isEditMode) {
                    await Vue.axios.delete(
                        `/UserGroup/${this.selectedGroup.UserGroupID}/RemoveUsers`,
                        { data: { Users: [user.UserID] } }
                    )
                } else {
                    Events.$emit(
                        'user-manage',
                        _.map(this.usersInGroup, 'UserID')
                    )
                }
                this.updateUserListInParentView()
                this.$nextTick(() => {
                    this.isDeleteInProgress = false
                })
            } catch (error) {
                return false
            }
        },
        updateUserListInParentView() {
            if (this.isEditMode) {
                Events.$emit('update-user-group-list')
            }
        },
    },
}
</script>
<style>
</style>
